import { Entypo, MaterialIcons } from '@native-base/icons';
import { HStack, Icon, Spacer, Text } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

import moneyDisplay from '../../../../helpers/moneyDisplay';
import dateDisplay from '../../../../helpers/dateDisplay';

function HistoryItem({ item }) {
  return (
    <HStack bg="gray.100" px="4" py="4" height="60" alignItems="center">
      <Text>{dateDisplay(item.timestamp)}</Text>
      <Spacer />
      <Icon as={MaterialIcons} name="euro" size="sm" color="gray.500" mr="2" />
      <Text color="gray.500">{moneyDisplay(item.cost)}</Text>
      <Spacer />
      <Icon as={Entypo} name="arrow-bold-up" size="sm" color="red.500" mr="2" />
      <Text color="red.500">{moneyDisplay(item.payment)}</Text>
      <Spacer />
      <Icon
        as={Entypo}
        name="arrow-bold-down"
        size="sm"
        color="green.500"
        mr="2"
      />
      <Text color="green.500">{moneyDisplay(item.returns)}</Text>
    </HStack>
  );
}

HistoryItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default HistoryItem;
